var _rect, _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuClientsSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F999B0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0189 28.9622C23.1882 28.9622 29 23.1503 29 15.9811C29 8.81183 23.1882 3 16.0189 3C8.84967 3 3.03784 8.81183 3.03784 15.9811C3.03784 23.1503 8.84967 28.9622 16.0189 28.9622ZM16.0189 25.9622C21.5313 25.9622 26 21.4935 26 15.9811C26 10.4687 21.5313 6 16.0189 6C10.5065 6 6.03784 10.4687 6.03784 15.9811C6.03784 21.4935 10.5065 25.9622 16.0189 25.9622Z",
    fill: "#FCFCFC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0189 25.9622C21.5313 25.9622 26 21.4935 26 15.9811C26 10.4687 21.5313 6 16.0189 6C10.5065 6 6.03784 10.4687 6.03784 15.9811C6.03784 21.4935 10.5065 25.9622 16.0189 25.9622ZM16.0189 22.9622C19.8745 22.9622 23 19.8366 23 15.9811C23 12.1255 19.8745 9 16.0189 9C12.1634 9 9.03784 12.1255 9.03784 15.9811C9.03784 19.8366 12.1634 22.9622 16.0189 22.9622Z",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0189 22.9622C19.8745 22.9622 23 19.8366 23 15.9811C23 12.1255 19.8745 9 16.0189 9C12.1634 9 9.03784 12.1255 9.03784 15.9811C9.03784 19.8366 12.1634 22.9622 16.0189 22.9622ZM16.0189 19.9622C18.2176 19.9622 20 18.1798 20 15.9811C20 13.7824 18.2176 12 16.0189 12C13.8202 12 12.0378 13.7824 12.0378 15.9811C12.0378 18.1798 13.8202 19.9622 16.0189 19.9622Z",
    fill: "#FCFCFC"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0189 19.9622C18.2176 19.9622 20 18.1798 20 15.9811C20 13.7824 18.2176 12 16.0189 12C13.8202 12 12.0378 13.7824 12.0378 15.9811C12.0378 18.1798 13.8202 19.9622 16.0189 19.9622ZM16.0189 17.9622C17.113 17.9622 18 17.0752 18 15.9811C18 14.887 17.113 14 16.0189 14C14.9248 14 14.0378 14.887 14.0378 15.9811C14.0378 17.0752 14.9248 17.9622 16.0189 17.9622Z",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0189,
    cy: 15.9811,
    r: 1.98108,
    fill: "#FCFCFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClientsSelected);
export default __webpack_public_path__ + "static/media/menu-clients-selected.2ca68a52d7fa6e0fc68327d57451bf3b.svg";
export { ForwardRef as ReactComponent };